import axios from 'axios'

import { redirectOnSessionExpired } from './redirectOnSessionExpired'
import { V3RequestInterceptor } from './v3'
import { ApiResponseError } from '../../errors/api'

export const genericApi = axios.create()

genericApi.defaults.xsrfHeaderName = 'X-CSRFToken'
genericApi.defaults.xsrfCookieName = 'csrftoken'

// using v3RequestInterceptor to set headers and get request params
genericApi.interceptors.request.use(V3RequestInterceptor)

export const GenericApiResponseErrorInterceptor = (error) => {
  if (error.response) {
    throw new ApiResponseError(error.response, error.toString())
  }

  throw error
}

genericApi.interceptors.response.use(
  (response) => response,
  GenericApiResponseErrorInterceptor
)

genericApi.interceptors.response.use(null, redirectOnSessionExpired)
